/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";

import { ItemContainer, ItemLabel } from "../../../../components/styled";
import { TestIds } from "../../../../testIds";

interface RemoveButtonProps {
  onRemove: () => void;
}
export const RemoveButton: React.FC<RemoveButtonProps> = ({ onRemove }) => {
  return (
    <ItemContainer wrap={false} sx={{ position: "absolute", right: 16, top: 16 }}>
      <ItemLabel
        variant="body2"
        align="right"
        sx={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={onRemove}
        data-testid={TestIds.feat.product.card.cartRemoveButton}
      >
        Remove
      </ItemLabel>
    </ItemContainer>
  );
};
